// src/components/ui/about/cta.tsx

import CtaButtonClient from "~/components/ui/about/CtaButton.client"

const companyHighlights = [
  "Innovative AI technology",
  "Multi-channel optimization",
  "Data-backed decision making",
  "Deep creative insights",
  "Continuous improvement",
  "Cutting-edge marketing tech"
]

export default function CtaSection(): JSX.Element {
  return (
    <section className="relative isolate overflow-hidden bg-gray-100 dark:bg-gray-900" aria-labelledby="cta-heading">
      <div className="px-4 py-12 sm:px-6 sm:py-8 md:py-24 lg:px-8">
        <div className="mx-auto max-w-4xl">
          <h2 id="cta-heading" className="text-2xl font-bold tracking-tight sm:text-3xl text-center md:text-4xl lg:text-5xl text-gray-900 dark:text-white">
            Join us in shaping the future. Optimize performance today.
          </h2>
          <p className="mx-auto mt-4 sm:mt-6 max-w-xl text-base sm:text-lg md:text-xl leading-7 sm:leading-8 text-gray-600 dark:text-gray-300 text-center">
            Discover how our AI-powered solutions can transform your creative workflow and boost productivity.
          </p>
          <div className="mt-8 sm:mt-10 flex justify-center">
            <ul className="grid grid-cols-2 gap-x-8 gap-y-2 sm:gap-y-3 text-left" aria-label="Company highlights">
              {companyHighlights.map((highlight) => (
                <li key={highlight} className="flex gap-x-2 items-center">
                  <svg
                    className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0 text-indigo-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="text-gray-600 dark:text-gray-300">{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-8 sm:mt-10 flex items-center justify-center gap-4">
            <CtaButtonClient />
          </div>
        </div>
      </div>
      <div
        className="absolute left-1/2 top-0 -z-10 -translate-x-1/2 blur-3xl xl:-top-6"
        aria-hidden="true"
      >
        <div
          className="aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#8B2469] to-[#170C8A] opacity-30"
          style={{
            clipPath:
              "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
          }}
        />
      </div>
    </section>
  )
}